module.exports = "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDkuNzggMTcuNTYiPgogICAgPHBhdGggZD0iTTIuNDEgOC43N2w3LjA3IDcuMDhhMSAxIDAgMCAxLTEuNDEgMS40MUwuMjkgOS40OGExIDEgMCAwIDEgMC0xLjQxTDguMDguMjlhMSAxIDAgMCAxIDEuNDEgMCAxIDEgMCAwIDEgMCAxLjQyeiIgZmlsbD0iIzdlOThlNSIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-back.svg
// module id = Hjbt
// module chunks = 1